import { render, staticRenderFns } from "./ButtonKeys.vue?vue&type=template&id=0a2d1cf0&"
import script from "./ButtonKeys.vue?vue&type=script&lang=js&"
export * from "./ButtonKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports